import { AxiosResponse } from "axios";
import { API } from "../index";

export interface VoucherBookRulePayload {
  voucher_product: number;
  start_date: string;
  end_date: string;
  state: string;
  stock: number;
  type: string;
  usage_amount: number;
  usage_period_day: number;
  site: number;
}

export const voucherService = {
  getVoucherSendData: async (): Promise<AxiosResponse> => {
    return await API.get(`/voucher/user/`);
  },

  postValidateVoucher: async (): Promise<AxiosResponse> => {
    return await API.post(`/voucher/check-user-vouchers/`);
  },

  postVoucherStateById: async (itemId: number): Promise<AxiosResponse> => {
    return await API.post(`voucher/process/${itemId}/`);
  },

  deleteCancelGiftById: async (itemId: number): Promise<AxiosResponse> => {
    return await API.delete(`/voucher/cancel-user-voucher-gift/${itemId}/`);
  },

  getVoucherResponseByNum: async (phoneNum: string): Promise<AxiosResponse> => {
    return await API.get(`/voucher/user-voucher-gift/?recipient=${phoneNum}`);
  },

  patchReceiveVoucherGiftById: async (giftId: number): Promise<AxiosResponse> => {
    return await API.put(`/voucher/receive-user-voucher-gift/${giftId}/`);
  },

  listVoucherBookRules: async (): Promise<AxiosResponse> => {
    return await API.get(`/voucher/book-rule/?include_hidden=true`);
  },

  createVoucherBookRule: async (payload: VoucherBookRulePayload): Promise<AxiosResponse> => {
    return await API.post(`/voucher/book-rule/`, payload);
  },

  updateVoucherBookRule: async (id: number, payload: VoucherBookRulePayload): Promise<AxiosResponse> => {
    return await API.put(`/voucher/book-rule/${id}/`, payload);
  },

  deleteVoucherBookRule: async (id: number): Promise<AxiosResponse> => {
    return await API.delete(`/voucher/book-rule/${id}/`);
  },
};

export const getUserVoucherCount = async () => {
  return API.get('/voucher/unchecked-count/');
};

export const getUserPreCoupons = async (page: number) => {
  return API.get(`/precoupon/user/?page=${page}`);
};
